// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentZoneSubtitle_root__ActgH"};